// extracted by css-extract-rspack-plugin
export default {"tabs":"V4pPn1YNP7Y_2qQh","tabList":"zNiblqcDNB0ybOVC","tab":"iLkEOCDEXUZXWQyY","tabPanel":"k5WAb1GqA8_MrXCK"};